module.exports = __webpack_public_path__ + "img/pundix.9d970bfa.svg";